import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import styles from './styles.module.css';

const messages = defineMessages({
  ANALYTICS_DISABLED_MESSAGE: {
    id: 'ANALYTICS_DISABLED_MESSAGE',
    defaultMessage: 'Your account is not enabled for this service',
  },
});

const ServiceNotSupportedMsg = () => (
  <div className={`${styles.component} animate__animated animate__fadeIn`}>
    <Paper className={styles.card} elevation={1}>
      <Typography variant="headline" component="h3">
        <FormattedMessage {...messages.ANALYTICS_DISABLED_MESSAGE} />
      </Typography>
    </Paper>
  </div>
);

export default ServiceNotSupportedMsg;
